import React from 'react';
import Text from '../../../../BuildingBlocks/Text';
import { PropTypes } from 'prop-types';
import { NoResultsContainer } from '../styles';

const ErroredResults = ({ title, phone, description }) => (
  <NoResultsContainer>
    <Text.CopyBody color="error">{title}</Text.CopyBody>
    <Text.CopyParagraph color="error" noMargins>
      {description}
    </Text.CopyParagraph>
    <Text.CopyParagraph color="error" weight="bold">
      {phone}
    </Text.CopyParagraph>
  </NoResultsContainer>
);

ErroredResults.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired
};

export default ErroredResults;
